import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query';
import { QueryKey } from 'common/enums/query-key';
import { MyEstateDetails } from 'common/generated/types/my-estate-details';
import { getMyEstateById } from 'services/api/estates-api.service';

export default function useGetMyEstateById(
  estateId: string,
  options?: Omit<
    UndefinedInitialDataOptions<MyEstateDetails, Error, MyEstateDetails, string[]>,
    'queryFn' | 'queryKey'
  >,
) {
  return useQuery({
    queryKey: [QueryKey.Estate, 'my', estateId],
    queryFn: () => getMyEstateById(estateId),
    enabled: !!estateId,
    ...options,
  });
}
